<template>
  <div class="vtrllogin">
    <!-- <head>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0;"/>
        <meta charset="UTF-8">
        <title>VVG</title>
        
    </head> -->

    <body>
      <section class="bg">
        <img src="/static/images/bg.png" alt="VVG">
      </section>
      <section class="login">
        <div class="login-container">
          <h1>Login Here</h1>
          <form>
            <div class="input-group">
              <span class="input-group-addon">
                <img src="/static/images/mobile-number.png">
              </span>
              <input v-model="username" class="form-control" type="input" placeholder="Mobile Number" id="username">
            </div>
            <div class="input-group">
              <span class="input-group-addon">
                <img src="/static/images/password.png">
              </span>
              <input v-model="password" id="password" type="password" class="form-control" name="password" placeholder="Password">
            </div>
            <span class="error" style="text-align:center;color:red">{{ error }}</span>
            <div class="toggle-container">
              <label class="switch">
                <input type="checkbox" checked>
                <span class="slider round"></span>
              </label>
              <p>Remember me</p>
            </div>
            <div class="forget-password">
              <a href="#">Forget your Password?</a>
            </div>

          </form>
        </div>
      </section>
      <section class="submit-section">
        <button id="loginbutton" v-on:click="login(this)" class="btn btn-default">Sign In</button>
      </section>
      <!--<form class="form">
    			<input type="text" placeholder="Username" id="username" name="username">
    			<input type="password" placeholder="Password" id="password" name="password">
    			<button type="button" onclick="login()" id="login-button">Login</button>
                <br>
                <span class="error" style="text-align:center;color:red"></span>
    		</form>
    	</div>-->
<div class="custom-loading" v-if="this.$config.loading">
      <div class="custom-loading-box">
         <i class="fa fa-truck faa-passing-reverse animated " aria-hidden="true"></i>
      </div>
      </div>
    </body>
  </div>
</template>


<script>
/* eslint jsx-quotes: ["error", "prefer-double"] */
// import axios from "axios";
import $ from "jquery";

export default {
  name: "vtrllogin",
  data: () => ({
    //return {
    error: "",
    username: "",
    password: "",
    userAgent: ""
    //};
  }),
  mounted: function() {
    this.getUserAgent();
    this.call();
  },
  methods: {
    getUserAgent: function() {
      this.userAgent = navigator.userAgent;
      console.log("UserAgent : " + this.userAgent);
    },
    call: function() {
      var self = this;
      $.ajax({
        url: self.$config.API + "/v1/operator/home-page",
        type: "GET",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        success: function(data) {
          if (data.Code != 401) {
            self.$router.push("/operator/home-page");
          }
        }
      });
    },
    login: function() {
      var self = this;
      console.log("home route: " + self.$config.API);
      var error_msg = "";
      if (this.username == "" && this.password == "") {
        error_msg = "Username & Password can not be left empty";
      } else if (this.username == "") {
        error_msg = "Username can not be left empty";
      } else if (this.password == "") {
        error_msg = "Password can not be left empty";
      }

      if (error_msg != "") {
        this.error = error_msg;
        return;
      } else {
        // $("form .error").text("");
      }
      self.$config.loading = true;
      $.ajax({
        url: self.$config.API + "/v1/operator/login",
        type: "POST",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        data: {
          username: this.username,
          password: this.password,
          flag: "operator"
        },
        timeout: 10000,
        success: function(data) {
          self.$config.loading = false;
          if (data.status == "success") {
            var isSafety = 0;
            if (data.data != null) {
              isSafety = data.data.is_safety;
            }
            self.$router.push("/assets/assetselection?is_safety=" + isSafety);
            if (self.userAgent == "vtrleld_app") {
              Native.setUserName(self.username);
              Native.setIsSafety(isSafety);
            }

            this.logintrue = "true";
            console.log(this.logintrue);
            return true;
          } else {
            this.error = "Username or password not matched." + data.token;
          }
        },
        error: function(jqXHR, exception, textstatus) {
          self.$config.loading = false;
          //console.log(jqXHR.status)
          //console.log(jqXHR.responseText)
          if (textstatus === "timeout") {
            alert("Request timed out");
          } else if (jqXHR.status == 0) {
            self.error = "Remote server can not be reachable";
          } else {
            self.error = jqXHR.responseJSON.message;
          }
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/vtrllogin.vue